import { render, staticRenderFns } from "./KeywordsFieldWithAssistant.vue?vue&type=template&id=36ddac93&scoped=true"
import script from "./KeywordsFieldWithAssistant.vue?vue&type=script&lang=js"
export * from "./KeywordsFieldWithAssistant.vue?vue&type=script&lang=js"
import style0 from "./KeywordsFieldWithAssistant.vue?vue&type=style&index=0&id=36ddac93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ddac93",
  null
  
)

export default component.exports